module.exports = __webpack_public_path__ + "img/location-admin-icon.a5ff9114.svg";